import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyboard, midi, keys, piano"><path d="M8.75 13V21M15.25 13V21M7.25 3.75V12.75H10.25V3.75H7.25ZM13.75 3.75V12.75H16.75V3.75H13.75ZM3.75 3.75H20.25V21.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconKeyboard;
